import React, { useState, useEffect, useContext, useRef } from "react";
import "../../../constants/report.css";
import axios from "axios";
import { AuthContext } from "../../../contexts/AuthContext";
import { tempUrl, useStateContext } from "../../../contexts/ContextProvider";
import { Loader } from "../../../components";
import {
  Box,
  ButtonGroup,
  Button,
  Autocomplete,
  TextField,
} from "@mui/material";
import { Container, Form, Row, Col, Table } from "react-bootstrap";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import jsPDF from "jspdf";
import { useDownloadExcel } from "react-export-table-to-excel";
import SearchIcon from "@mui/icons-material/Search";
import PrintIcon from "@mui/icons-material/Print";
import useScreenWidth from "../../../hooks/useScreenWidth";

const LaporanHutangDendaFidusia = () => {
  const screenSize = useScreenWidth();
  const tableRef = useRef(null);
  const { user, dispatch, setting } = useContext(AuthContext);
  const reportTemplateRef = useRef(null);
  let nowDate = new Date();

  const [kodeCabang, setKodeCabang] = useState("");
  const [namaCabang, setNamaCabang] = useState("");

  const [cabangs, setCabangs] = useState([]);
  const [loading, setLoading] = useState(false);
  const [persenLoading, setPersenLoading] = useState("0");
  const [lapHutangDendasData, setLapPiutangLunassData] = useState([]);
  const [previewPdf, setPreviewPdf] = useState(false);
  const [isCetakExcel, setIsCetakExcel] = useState(false);
  const [error, setError] = useState(false);

  let cabangOptions = cabangs.map((cabang) => ({
    label: `${cabang.id} - ${cabang.namaCabang}`,
    id: `${cabang.id} - ${cabang.namaCabang}`,
  }));

  const handleGeneratePdf = () => {
    const doc = new jsPDF({
      orientation: "l",
      format: "a4",
      unit: "px",
    });
    doc.html(reportTemplateRef.current, {
      async callback(doc) {
        window.open(URL.createObjectURL(doc.output("blob")));
      },
      html2canvas: { scale: 0.32 },
    });
  };

  const tampilPdf = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    const form = e.currentTarget;
    if (form.checkValidity()) {
      setLoading(true);
      let tempPersenLoading = parseInt(persenLoading);

      setTimeout(() => {
        tempPersenLoading += 40;
        setPersenLoading(tempPersenLoading.toString());
      }, "1000");

      let piutangLunasFidusias = await axios.post(
        `${tempUrl}/laporanHutangDendaFidusia`,
        {
          kodeCabang,
          _id: user.id,
          token: user.token,
        }
      );
      setLapPiutangLunassData(piutangLunasFidusias.data);
      setPreviewPdf(!previewPdf);
      setLoading(false);
      setTimeout(() => {
        tempPersenLoading = 0;
        setPersenLoading(tempPersenLoading.toString());
      }, "2000");
    }
  };

  useEffect(() => {
    getCabangsData();
    if (user.tipeUser !== "OWNER/DIREKSI") {
      setKodeCabang(user.cabang.id);
      setNamaCabang(`${user.cabang.id} - ${user.cabang.namaCabang}`);
    }
  }, []);

  const getCabangsData = async () => {
    const response = await axios.post(`${tempUrl}/cabangs`, {
      _id: user.id,
      token: user.token,
      kodeCabang: user.cabang.id,
    });
    setCabangs(response.data);
  };

  const tableText = {
    letterSpacing: "0.01px",
  };

  const tableTextIsBayar = {
    letterSpacing: "0.01px",
    backgroundColor: "yellow",
  };

  const textNumberRight = {
    textAlign: "right",
    border: "1px solid black",
  };

  const list = [];
  let tempNo = 0;
  let tempTotalBayar = 0;
  let tempTotalBiayaSpk = 0;
  let tempTotalBayarDenda = 0;
  let tempTotalHutangDenda = 0;

  for (let i = 0; i < lapHutangDendasData.length; i++) {
    tempNo++;
    tempTotalBayar += lapHutangDendasData[i].bayar;
    tempTotalBiayaSpk += lapHutangDendasData[i].biayaSpk;
    tempTotalBayarDenda += lapHutangDendasData[i].bayarDenda;
    tempTotalHutangDenda += lapHutangDendasData[i].hutangDenda;

    list.push(
      <tr style={lapHutangDendasData[i].isBayar ? tableTextIsBayar : tableText}>
        <td style={{ paddingLeft: "15px", border: "1px solid black" }}>
          {tempNo}
        </td>
        <td style={{ border: "1px solid black" }}>
          {lapHutangDendasData[i].namaCustomer}
        </td>
        <td style={{ border: "1px solid black" }}>
          {lapHutangDendasData[i].noPerjanjian}
        </td>
        <td style={{ border: "1px solid black" }}>
          {lapHutangDendasData[i].tglJatuhTempoFormatted}
        </td>
        <td style={{ border: "1px solid black" }}>
          {lapHutangDendasData[i].tglBayarFormatted}
        </td>
        <td style={textNumberRight}>
          {isCetakExcel === false
            ? lapHutangDendasData[i].bayar.toLocaleString("en-EN")
            : lapHutangDendasData[i].bayar}
        </td>
        <td style={textNumberRight}>
          {isCetakExcel === false
            ? lapHutangDendasData[i].biayaSpk.toLocaleString("en-EN")
            : lapHutangDendasData[i].biayaSpk}
        </td>
        <td style={textNumberRight}>
          {isCetakExcel === false
            ? lapHutangDendasData[i].bayarDenda.toLocaleString("en-EN")
            : lapHutangDendasData[i].bayarDenda}
        </td>
        <td style={textNumberRight}>
          {isCetakExcel === false
            ? lapHutangDendasData[i].hutangDenda.toLocaleString("en-EN")
            : lapHutangDendasData[i].hutangDenda}
        </td>
      </tr>
    );
  }

  list.push(
    <tr style={tableText}>
      <td colSpan="5" style={{ border: "1px solid black" }}>
        TOTAL
      </td>
      <td style={textNumberRight}>
        {isCetakExcel === false
          ? tempTotalBayar.toLocaleString("en-EN")
          : tempTotalBayar}
      </td>
      <td style={textNumberRight}>
        {isCetakExcel === false
          ? tempTotalBiayaSpk.toLocaleString("en-EN")
          : tempTotalBiayaSpk}
      </td>
      <td style={textNumberRight}>
        {isCetakExcel === false
          ? tempTotalBayarDenda.toLocaleString("en-EN")
          : tempTotalBayarDenda}
      </td>
      <td style={textNumberRight}>
        {isCetakExcel === false
          ? tempTotalHutangDenda.toLocaleString("en-EN")
          : tempTotalHutangDenda}
      </td>
    </tr>
  );

  const { onDownload } = useDownloadExcel({
    currentTableRef: tableRef.current,
    filename: "LaporanHutangDendaFidusia",
    sheet: "LaporanHutangDendaFidusia",
  });

  const textRight = {
    textAlign: screenSize >= 650 && "right",
  };

  if (loading) {
    return <Loader persenLoading={persenLoading} />;
  }

  return (
    <Container>
      <h3>Laporan</h3>
      <h5 style={{ fontWeight: 400 }}>Laporan Hutang Denda Fidusia</h5>
      <hr />
      <Box sx={spacingTop}>
        <Form onSubmit={tampilPdf}>
          <Row>
            <Col sm={6}>
              <Form.Group
                as={Row}
                className="mb-3"
                controlId="formPlaintextPassword"
              >
                <Form.Label column sm="4" style={textRight}>
                  Cabang :
                </Form.Label>
                <Col sm="8">
                  {user.tipeUser === "OWNER/DIREKSI" ? (
                    <Autocomplete
                      size="small"
                      disablePortal
                      id="combo-box-demo"
                      options={cabangOptions}
                      renderInput={(params) => (
                        <TextField
                          error={error && kodeCabang.length === 0 && true}
                          size="small"
                          placeholder="SEMUA CABANG"
                          {...params}
                        />
                      )}
                      onChange={(e, value) => {
                        if (value) {
                          setKodeCabang(value.id.split(" ", 1)[0]);
                          setNamaCabang(value.id);
                        } else {
                          setKodeCabang("");
                          setNamaCabang("");
                        }
                        setPreviewPdf(false);
                      }}
                      defaultValue={kodeCabang}
                    />
                  ) : (
                    <Form.Control value={kodeCabang} disabled readOnly />
                  )}
                </Col>
              </Form.Group>
            </Col>
          </Row>
          <Button
            variant="contained"
            startIcon={<SearchIcon />}
            type="submit"
            style={{ marginTop: "20px" }}
          >
            LIHAT
          </Button>
        </Form>
      </Box>

      {previewPdf && (
        <div style={{ marginTop: "10px" }}>
          <ButtonGroup variant="outlined" color="secondary">
            <Button
              variant="outlined"
              startIcon={<PrintIcon />}
              onClick={handleGeneratePdf}
            >
              PDF
            </Button>
            <Button
              startIcon={<SearchIcon />}
              onClick={() => {
                setIsCetakExcel(true);
                setTimeout(() => {
                  onDownload();
                }, "1000");
              }}
            >
              Excel
            </Button>
          </ButtonGroup>
        </div>
      )}
      <div ref={reportTemplateRef} id="content" style={pdfContainer}>
        <div style={{ visibility: previewPdf === true ? "visible" : "hidden" }}>
          <p>
            {setting.namaPerusahaan} - {setting.alamatPerusahaan}
          </p>
          <p>({setting.kabupatenPerusahaan})</p>
          <p>{setting.kotaPerusahaan}</p>
          <p>NO. TELP. {setting.teleponPerusahaan}</p>
          <p>
            Dicetak Oleh: {user.username} | Tanggal:
            {` ${nowDate.getDate().toLocaleString("en-US", {
              minimumIntegerDigits: 2,
              useGrouping: false,
            })}/${(nowDate.getMonth() + 1).toLocaleString("en-US", {
              minimumIntegerDigits: 2,
              useGrouping: false,
            })}/${nowDate.getFullYear()} `}{" "}
            | Jam:{" "}
            {` ${nowDate.getHours().toLocaleString("en-US", {
              minimumIntegerDigits: 2,
              useGrouping: false,
            })}:${(nowDate.getMinutes() + 1).toLocaleString("en-US", {
              minimumIntegerDigits: 2,
              useGrouping: false,
            })}:${nowDate.getSeconds().toLocaleString("en-US", {
              minimumIntegerDigits: 2,
              useGrouping: false,
            })} `}
          </p>
          <h5 style={{ textAlign: "center", fontWeight: "700" }}>
            Laporan Hutang Denda Fidusia
          </h5>
          <p>Cabang : {namaCabang}</p>
          <p></p>
          <table class="styled-table" ref={tableRef}>
            <thead>
              <tr>
                <th style={{ border: "1px solid black" }}>No</th>
                <th style={{ border: "1px solid black" }}>Nasabah</th>
                <th style={{ border: "1px solid black" }}>No. Pk</th>
                <th style={{ border: "1px solid black" }}>Jto</th>
                <th style={{ border: "1px solid black" }}>Tgl Bayar</th>
                <th style={{ border: "1px solid black" }}>Pembayaran</th>
                <th style={{ border: "1px solid black" }}>Hutang SPK</th>
                <th style={{ border: "1px solid black" }}>Pembayaran Denda</th>
                <th style={{ border: "1px solid black" }}>Hutang Denda</th>
              </tr>
            </thead>
            <tbody>{list}</tbody>
          </table>
        </div>
      </div>
    </Container>
  );
};

export default LaporanHutangDendaFidusia;

const spacingTop = {
  mt: 4,
};

const pdfContainer = {
  padding: "20px",
  letterSpacing: "0.01px",
  fontSize: "12px",
  fontFamily: "sans-serif",
  width: "1000px",
  display: "table",
};
